<template>
  <div style="height: 100%" class="d-flex flex-column">
    <div>
      <v-container class="smartphone-block pt-0 px-0 pb-0" fill-height>
        <v-row class="title-row" align="center">
          <mf-icon class="ml-3">arrow_back_ios</mf-icon>
          <mf-icon large>lens</mf-icon>
          <div class="ml-2">
            <div class="first-line" />
            <div class="second-line" />
          </div>
          <v-spacer />
          <mf-icon large>stop</mf-icon>
          <mf-icon class="mr-3" large>stop</mf-icon>
          <mf-icon class="mr-3" large>more_vert</mf-icon>
        </v-row>
        <v-row
          v-for="(message, index) in messages"
          :key="`messagePreview${index}`"
          class="content-row content-row-expanded"
          fill-height
          :justify="message.fromBot ? 'start' : 'end'"
        >
          <v-col :class="[message.fromBot ? 'bubble-block-bot' : 'bubble-block-consumer']" align-self="start">
            <div class="message">
              <span v-for="(msg, index) of splitText(message.text)" :key="index" v-html-safe="getWhatsappRevisedText(msg)" />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="bottom-filler" />
  </div>
</template>

<script>
export default {
  props: {
    menuOptions: {
      type: Array,
      default: () => [],
    },
    menuMessage: {
      type: String,
    },
    selectedMenuOptionMessages: {
      type: Array,
    },
  },
  computed: {
    previewFlowMenuMessage() {
      const menuOptions = this.menuOptions
        .filter((option) => option.active)
        .map((option, index) => `${index + 1} - ${option.menu_name}`)
        .join('\n')
      return this.menuMessage.replaceAll('[menu]', menuOptions)
    },

    messages() {
      let messages = [
        {
          text: this.previewFlowMenuMessage,
          fromBot: true,
        },
      ]
      if (this.selectedMenuOptionMessages?.length) {
        messages = messages.concat(this.selectedMenuOptionMessages)
      }
      messages = messages.filter(({ text }) => text)
      return messages
    },
  },
  methods: {
    splitText(message) {
      if (!message) return []
      return message.split('\n')
    },
    getWhatsappRevisedText(text) {
      return `${text}<br />`
    },
  },
}
</script>

<style lang="scss">
.table-card-title-whats {
  font-size: 18px;
  color: $cinza-d10;
  @extend .card-title;
}

.bottom-filler {
  flex-grow: 1;
  background-color: #ecf2fe;
}

.smartphone-block {
  margin-right: -12px;
  .message-preview-title {
    margin-left: -12px;
    padding-bottom: 30px;
  }
  .title-row {
    background-color: #d6e3fe;
    height: 60px;
    .first-line {
      width: 85px;
      height: 10px;
      background-color: #b3cafe;
      border-radius: 2px;
    }
    .second-line {
      width: 150px;
      height: 8px;
      background-color: #b3cafe;
      margin-top: 4px;
      border-radius: 2px;
    }
    i {
      color: #b3cafe;
    }
  }
  .content-row {
    overflow: auto;
    background-color: #ecf2fe;
    .bubble-block-consumer {
      max-width: 100px;
      .message {
        background-color: $ilustracao-solid-4 !important;
        border-radius: 4px;
        padding: 8px;
        color: $cinza-d20 !important;
      }
    }
    .bubble-block-bot {
      max-width: 85%;
      .message {
        background-color: #b5caf7 !important;
        border-radius: 4px;
        padding: 8px;
        color: $cinza-d20 !important;
      }
    }
  }
}

.variable-highlight {
  color: $marca-1;
}

.variable-error {
  color: #d83e3e !important;
}

.variable-error-super {
  .variable-highlight {
    color: $marca-1 !important;
  }
  color: #d83e3e !important;
}
</style>
